<!-- 
  @desc U系列比赛
-->
<template>
  <game></game>
</template>
<script>
import Game from "@/components/game/u/game/Index.vue";
export default {
  components: {
    Game
  }
};
</script>
<style lang="scss"></style>
